import { makeAutoObservable } from "mobx";
import { storageService } from "../../utilities/service/StorageService";
import { toastMsg } from "../../utilities/helpers/ToastHelper";
import { headerState } from "../../share/layout/header/HeaderState";
class CartState{
    constructor(){
        makeAutoObservable(this)
    }
    openModalStatus: boolean = false;
    dishCartList: any[] = [];
    dishSpecificInfo: any;
    getDishCartList(){
        const dataDishLocal = storageService.getDishInCart();
        this.dishCartList = dataDishLocal ? dataDishLocal : [];
    }
    async submitDishes(){
    }
    handleDeleteDishInCart(dishID:number){
        this.dishCartList = this.dishCartList.filter((dish:any)=>Number(dish.id) !== dishID);
        storageService.setDishInCart(this.dishCartList).then(()=>{
            this.dishCartList = storageService.getDishInCart()
        })
        this.openModalStatus = false;
    }
    handleOpenModal(dishData:any){
        this.dishSpecificInfo = dishData;
        this.openModalStatus = true;
    }
    handleCloseModal(){
        this.openModalStatus = false;
    }
    handleChangeAmount(type: string, dishData:any){
        const dishID = dishData.id;
        const needyDish = this.dishCartList.find((dish:any)=> Number(dish.id) === Number(dishID))
        if(type === 'minus'){
            if(Number(needyDish.quantity) === 1){
                this.dishSpecificInfo = dishData;
                this.handleOpenModal(dishData);
            }
            else{
                this.dishCartList.find((dish:any)=> Number(dish.id) === Number(dishID)).quantity = (Number(this.dishCartList.find((dish:any)=> Number(dish.id) === Number(dishID)).quantity) - 1)
                storageService.setDishInCart(this.dishCartList)
            }
        }
        else if(type === 'plus'){
            this.dishCartList.find((dish:any)=> Number(dish.id) === Number(dishID)).quantity = (Number(this.dishCartList.find((dish:any)=> Number(dish.id) === Number(dishID)).quantity) + 1)
            storageService.setDishInCart(this.dishCartList)
        }
    }
    directToDish(dishID:any, navigate:any){
        navigate(`/meal/${dishID}`);
        storageService.setSelectedItemInMainMenu('menu');
        headerState.amount += 1;
    }
}
export const cartState = new CartState()